/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated skills metrics for a single skill
 */
export type SkillSummary = {
  /**
   * Skill name (extracted from tool name)
   */
  skillName: string;
  /**
   * Number of unique users who used this skill
   */
  uniqueUsers: number;
  /**
   * Total number of times this skill was used
   */
  useCount: number;
};

/** @internal */
export const SkillSummary$inboundSchema: z.ZodMiniType<SkillSummary, unknown> =
  z.pipe(
    z.object({
      skill_name: z.string(),
      unique_users: z.int(),
      use_count: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "skill_name": "skillName",
        "unique_users": "uniqueUsers",
        "use_count": "useCount",
      });
    }),
  );

export function skillSummaryFromJSON(
  jsonString: string,
): SafeParseResult<SkillSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillSummary' from JSON`,
  );
}
